/* eslint-disable */
import React, { useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { CTitle, TTitle } from '../../components/Widget';
import ArrowImg from '../../../../../../assets/cybersecurity2026/finger.gif';
import Icon1 from '../../../../../../assets/cybersecurity2026/topic1600/attentions/icon1.png';
import Icon2 from '../../../../../../assets/cybersecurity2026/topic1600/attentions/icon2.png';
import Icon3 from '../../../../../../assets/cybersecurity2026/topic1600/attentions/icon3.png';
import Icon4 from '../../../../../../assets/cybersecurity2026/topic1600/attentions/icon4.png';
import Img from '../../../../../../assets/cybersecurity2026/topic1600/risk/img.png';
import Img1 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_1.png';
import Img2 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_2.png';
import Img3 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_3.png';
import Img4 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_4.png';
import Img5 from '../../../../../../assets/cybersecurity2026/topic1600/risk/img_5.png';
import DataAnalysis from '../../../../../../assets/cybersecurity2026/topic1600/data-analysis.png';
import link0 from '../../../../../../assets/cybersecurity2026/topic1600/link_pic.png';
import link1 from '../../../../../../assets/cybersecurity2026/topic1600/link_1.png';
import link2 from '../../../../../../assets/cybersecurity2026/topic1600/link_2.png';
import link3 from '../../../../../../assets/cybersecurity2026/topic1600/link_3.png';
import { useUpdateComponentState } from '../../../hooks';
import topBox from '../../../../../../assets/cybersecurity2026/topic1600/top-box-img.png';
import { Modal } from 'antd';
import { useStore } from '../../../../store';
import phishing from '../../../../../../assets/cybersecurity2026/topic1600/section1_1.png';

interface ISection1Props {
  settings: any;
}

const Section1: React.FunctionComponent<ISection1Props> = ({ settings }) => {
  const ID = '2';
  const { language } = useStore();
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const paragraphsSettings = useMemo(
    () => settings?.paragraphs[1],
    [settings?.paragraphs]
  );
  const [state, setState] = React.useState({
    play: 1,
    isPlayed: false,
  });
  // 使用对象来分别跟踪每个tab的已点击链接
  const [clickedLinks, setClickedLinks] = useState<any>({
    A: new Set(),
  });
  const numToImg:any = (index: any): string => {
    const imgMap: any = {
      0: link0,
      1: link1,
      2: link2,
      3: link3,
    };
    return imgMap[index];
  };
  const [activeTab, setActiveTab] = useState<any>('A');
  const [open, setOpen] = useState<boolean>(false);
  const [linkPic, setLinkPic] = useState<string>();
  const [explanation, setExplanation] = useState<string>('');
  const [falsifyClicked, setFalsifyClicked] = useState<[boolean, boolean, boolean]>([
    false,
    false,
    false,
  ]);
  const falsifyArrowStep = useMemo<1 | 2 | 3 | 4>(() => {
    if (!falsifyClicked[0]) return 1;
    if (!falsifyClicked[1]) return 2;
    if (!falsifyClicked[2]) return 3;
    return 4; // 全部点击后隐藏
  }, [falsifyClicked]);
  // 显示图片模态框
  const showPicFn = (item: any) => {
    setLinkPic(numToImg(0));
    setExplanation('');
    setOpen(true);

    // 记录当前tab已点击的链接
    if (item.link) {
      setClickedLinks((prev: any) => ({
        ...prev,
        [activeTab]: new Set(prev[activeTab]).add(item.link!),
      }));
    }
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1600-section1-3'
    );
  };
  // 点击箭头图标时触发动画
  const handleArrowClick = () => {
    if (!animationStarted) {
      setAnimationStarted(true);
      // 从第二条开始显示（第一条已经显示）
      setVisibleCount(2);
      updateComponentState(
        p_course,
        p_topic,
        ID,
        'cybersecurity2026-topic1600-section1-4'
      );
    }
  };
  // 渲染内容列表
  const renderContentList = (contentList: any[]) => (
    <div className="content-list">
      {contentList?.map((item, index) => (
        <div key={item.id + index} className="content-item">
          <div>
            {item.text}
            {item.link && (
              <>
                <span className="content-pic" onClick={() => showPicFn(item)}>
                  {paragraphsSettings.clickToViewImage}
                </span>
                {/* 只有未点击过的链接才显示箭头 */}
                {!clickedLinks[activeTab].has(item.link) && (
                  <span className="content-arrow" />
                )}
              </>
            )}
          </div>
        </div>
      ))}
    </div>
  );
  const onFalsify = (itemNo: any) => {
    setLinkPic(numToImg(itemNo));
    setOpen(true);
  }
  const onFalsifyWithArrow = (index1Based: 1 | 2 | 3, explanationText?: string) => {
    onFalsify(index1Based);
    setExplanation(explanationText || '');
    setFalsifyClicked((prev) => {
      const next: [boolean, boolean, boolean] = [...prev] as any;
      next[index1Based - 1] = true;
      if (next[0] && next[1] && next[2]) {
        updateComponentState(
          p_course,
          p_topic,
          ID,
          'cybersecurity2026-topic1600-section1-2'
        );
      }
      return next;
    });
  };
  const noToImg = (no: '01' | '02' | '03' | '04'): string => {
    const imgMap: Record<'01' | '02' | '03' | '04', string> = {
      '01': Icon1,
      '02': Icon2,
      '03': Icon3,
      '04': Icon4,
    };
    return imgMap[no];
  };
  const riskToImg = (no: 0 | 1 | 2 | 3 | 4 | 5): string => {
    const imgMap: Record<0 | 1 | 2 | 3 | 4 | 5, string> = {
      0: Img,
      1: Img1,
      2: Img2,
      3: Img3,
      4: Img4,
      5: Img5,
    };
    return imgMap[no];
  };
  const updateComponentState = useUpdateComponentState();
  const [visibleCount, setVisibleCount] = useState(1); // 默认显示第一条
  const [animationStarted, setAnimationStarted] = useState(false); // 控制动画是否已开始
  const startPlay = (next = 1) => {
    if (state.isPlayed) {
      return;
    }
    next += 1;
    setState({ play: next, isPlayed: true });
    updateComponentState(
      p_course,
      p_topic,
      ID,
      'cybersecurity2026-topic1600-section1-1'
    );
    if (next <= 4) {
      setTimeout(() => startPlay(next), 1000);
    }
  };
  React.useEffect(() => {
    // 如果动画还未开始，则不自动播放
    if (!animationStarted) return;

    // 如果已经显示完所有项目，则停止
    if (visibleCount >= paragraphsSettings.risks?.length) return;

    const timer = setTimeout(() => {
      setVisibleCount((v) => v + 1);
    }, 600);

    return () => clearTimeout(timer);
  }, [visibleCount, animationStarted, paragraphsSettings.risks?.length]);
  return (
    <>
      <div className="topic-section-1">
        <CTitle title={paragraphsSettings?.title} />
        <div
          id="cybersecurity2026-topic1600-section1-1"
          className="attentions-container"
        >
          <div className="content" onClick={() => startPlay()}>
            <div
              className="tip"
              dangerouslySetInnerHTML={{ __html: paragraphsSettings?.l1 }}
            />
            <TTitle title={paragraphsSettings?.l2} />
            <div
              className="arrow"
              style={{ display: state.isPlayed ? 'none' : 'block' }}
            >
              <img src={ArrowImg} alt="" />
            </div>
            <div className="item-wrap">
              {paragraphsSettings?.l10?.map(
                (item: { no: string; desc: string }, index: number) => (
                  <div
                    key={item.no}
                    className={`attention-item ${
                      state.play > index + 1 ? 'fade-in' : ''
                    }`}
                  >
                    <div className="item-no">
                      <img
                        src={noToImg(item.no as '01' | '02' | '03' | '04')}
                        alt=""
                      />
                    </div>
                    <div className="item-desc">{item.desc}</div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
        <div className="falsify">
          <div className="falsify-title">{paragraphsSettings?.l3}</div>
          <div className="falsify-content">
            {paragraphsSettings?.falsify?.map((item: any, index: number) => (
              <div className="falsify-content-item" key={item.no}>
                <div className="item-title">{item.title}</div>
                {item.no === '01' && (
                  <div className="item-wrap item-01-wrap">
                    <img className="item-img" src={DataAnalysis} alt="" />
                    {item?.arr?.map((subItem: any, index: number) => (
                      <div className="item-01-arr" key={index}>
                        {subItem?.title}
                      </div>
                    ))}
                  </div>
                )}
                {item.no === '02' && (
                  <div className="item-wrap item-02-wrap">
                    {item?.arr?.map((subItem: any, index: number) => (
                      <div className="item-02-arr" key={index}>
                        <h5>{subItem?.num}</h5>
                        <span>{subItem?.title}</span>
                      </div>
                    ))}
                  </div>
                )}
                {item.no === '03' && (
                  <div className="item-wrap item-03-wrap" id="cybersecurity2026-topic1600-section1-2">
                    {item?.arr?.map((subItem: any, index: number) => (
                      <div
                        className="item-03-arr"
                        style={{
                          flex: subItem?.num,
                          background: subItem?.color,
                        }}
                        key={index}
                        onClick={() => onFalsifyWithArrow((index + 1) as 1 | 2 | 3, subItem?.explanation)}
                      >
                        {falsifyArrowStep <= 3 && falsifyArrowStep === (index + 1) && (
                          <img className="item-03-arrow" src={ArrowImg} alt="" />
                        )}
                        <span className="num">{subItem?.num}</span>
                        <span className="subItem-title">{subItem?.title}</span>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <TTitle title={paragraphsSettings?.l4} />
        </div>
        <div className="tabs-content">
          <div className="top-box">
            <img className="top-box-img" src={topBox} alt="" />
          </div>
          <div className="tabs-style">
            <h3>{paragraphsSettings?.l5}</h3>
            <div
              className="tab-a-title"
              id="cybersecurity2026-topic1600-section1-3"
            >
              {paragraphsSettings?.l6}
            </div>
            <div className="tab-a-content">
              <div className="tab-a-content-left" />
              <div className="tab-a-content-right">
                {renderContentList(paragraphsSettings?.caseContent)}
              </div>
            </div>
          </div>
        </div>
        <div className="tampering">
          <i className="back_piece"></i>
          <div className="content" id="cybersecurity2026-topic1600-section1-4">
            {!animationStarted && (
              <img className="arrow-img" src={ArrowImg} alt="" />
            )}

            <div className="right-pic">
              <div className="risks-title">
                {paragraphsSettings?.risksTitle}
              </div>
              <img src={phishing} alt="" />
            </div>
            <div className="left-list"  onClick={handleArrowClick}>
              {paragraphsSettings.risks?.map((r: any, i: number) => (
                <div
                  key={i}
                  className="risk-item"
                  data-show={i < visibleCount}
                  style={{
                    cursor:
                      i === 0 && !animationStarted ? 'pointer' : 'default',
                  }}
                >
                  <div className="risk-title">
                    <img
                      className="risk-img"
                      src={riskToImg(i as any)}
                      alt=""
                    />
                    <span>{r.title}</span>
                  </div>
                  <div className="risk-desc">
                    <div className="risk-desc-text">{r.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      <Modal
        title=""
        width="80%"
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        wrapClassName="topic1600-modal"
        getContainer={false}
      >
          <div className="modal-img">
            <img src={linkPic} alt="" />
          </div>
          {explanation && <div className="explanation-text" dangerouslySetInnerHTML={{ __html: explanation }} />}
      </Modal>
    </>
  );
};

export default Section1;
